module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_1.e1ee8bca.png";